import React from "react"
import PropTypes from "prop-types"
import Link from "gatsby-link"
import ConnectedCounter from '../components/ConnectedCounter'
import ConnectedModalApp from '../components/ConnectedModalApp'
import ConnectedNav from '../components/ConnectedNav'
import Footer from '../components/Footer'
import { connect } from "react-redux"
import ConnectedCookieConsent from '../components/ConnectedCookieConsent'
import { Cookies } from 'react-cookie-banner'
import * as actions_cookies from './../actions/cookieconsent'
import './styles.sass';
import './styles.css'
import * as actions_nav from '../actions/nav'
import { IntlProvider, addLocaleData } from 'react-intl'
// Locale data

import enData from 'react-intl/locale-data/en'
import deData from 'react-intl/locale-data/de'
import ruData from 'react-intl/locale-data/ru'

// Messages
import de from '../i18n/de.json'
import en from '../i18n/en.json'
import ru from '../i18n/ru.json'

const messages = { de, en, ru }



class DefaultLayout extends React.Component {

  constructor(props) {
      super(props);
      this.state = {

      };
  }

  componentDidMount(){
    
    var ga_approved = document.cookie.replace(/(?:(?:^|.*;\s*)ub_ga\s*\=\s*([^;]*).*$)|^.*$/, "$1");

  /*
  //  console.log('ga approved: ' + ga_approved);

    if( ! ga_approved ){
    window['ga-disable-UA-xxxxxx-xx'] = true;
  //  console.log('ga disabled');

    }
    window.ga=window.ga||function(){(ga.q=ga.q||[]).push(arguments)};ga.l=+new Date;
    ga('create', 'UA-xxxxxx-xx', 'auto');
    ga('set', 'anonymizeIp', true);
    ga('send', 'pageview');
    */
  }




  render(props) {

    var _pth  = this.props.location.pathname.split('/')
    var _lng = 'en'
    if(_pth.length > 0){
     _lng = _pth[1] !== '' ? _pth[1] : 'en'
     }

    return (
      <IntlProvider locale={_lng} messages={messages[_lng]}>
      <div className={'main_inner overlay-' + this.props.modalVisible}>
        <ConnectedModalApp
        history={this.props.history}
        location={this.props.location}
        lang={_lng}
        _lang={_lng}
        screenHeight={this.props.screenHeight} screenWidth={this.props.screenWidth}
        pf_id={this.props.pf_id}
        img_id={this.props.img_id}
        />
        <ConnectedNav
        location = {this.props.location.pathname}
        links = {messages[_lng] != null ? messages[_lng].links : messages['en']}
        lang={_lng}
        _lang={_lng}
        music={false}
        />
        <div className="content-wrapper">

        {this.props.children()}
        <Footer message={messages[_lng] != null ? messages[_lng] : messages['de']} locale={_lng} showSettings={this.props.showSettings} show_settings={this.props.show_settings} hide_settings={this.props.hide_settings}/>

        <ConnectedCookieConsent
        showSettings={this.props.showSettings}
        cookies_all={this.props.cookies_all}
        cookies_analytics={this.props.cookies_analytics}
        location={this.props.location.pathname}
        message={messages[_lng] != null ? messages[_lng] : messages['en']}
        />
        </div>
      </div>
      </IntlProvider>
    )
  }
}

const mapStateToProps = ({ lang, music, modalVisible, pf_id, img_id, screenWidth, screenHeight, cookies_all, cookies_analytics, showSettings, show_settings, hide_settings }) => {
  return { lang, music, modalVisible, pf_id, img_id, screenWidth, screenHeight, cookies_all, cookies_analytics, showSettings, show_settings, hide_settings }
}

const mapDispatchToProps = dispatch => {
  return {
    show_settings: () => dispatch(actions_cookies.show_settings()),
    hide_settings: () => dispatch(actions_cookies.hide_settings()),
    hide_settings: () => dispatch(actions_cookies.hide_settings()),
    lang_de: () => dispatch(actions_nav.lang_de()),
    lang_en: () => dispatch(actions_nav.lang_en()),
    lang_ru: () => dispatch(actions_nav.lang_ru())
   }
}
export default connect(mapStateToProps, mapDispatchToProps)(DefaultLayout)



// WEBPACK FOOTER //
// ./src/layouts/index.js